export class KYMW9004InputModel {
  /** 権限セットID */
  public authoritySetId: string = <string>'';
}